import { useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";

import { ConsultationIntroScreen } from "~/patients/components/consultations";
import { useScreeningIntroScreenVisit } from "~/patients/hooks/queries";
import { useGetCurrentPatient } from "~/patients/hooks/queries/useGetCurrentPatient";
import { ROUTES } from "~/patients/router/routes";
import { PatientInformation } from "~/patients/utils";

const getScreeningIntroScreenMessage = (user?: PatientInformation) => (
  <div className="flex flex-col gap-4 text-base font-light text-gray-700">
    <p>Hi {user?.name},</p>
    <p>
      Your consultation begins now with some online questions. These questions
      are an essential part of the process. Therefore, it’s important that your
      responses be as thorough and thoughtful as possible.
    </p>
    {user?.organization_patients[0]?.primary_provider && (
      <div className="space-y-0">
        <p>Warmly,</p>
        <p className="text-xl font-semibold">
          {user.organization_patients[0].primary_provider.signature_name}
        </p>
      </div>
    )}
  </div>
);

export const ScreeningIntroScreen = () => {
  const navigate = useNavigate();
  const { data: user } = useGetCurrentPatient();

  const queryClient = useQueryClient();

  const onSuccess = async () => {
    await queryClient.invalidateQueries({
      queryKey: ["getCurrentPatient"],
    });
    navigate(ROUTES.leadPatientHome);
  };

  const { screeningIntroScreenVisitMutation } =
    useScreeningIntroScreenVisit(onSuccess);

  return (
    <ConsultationIntroScreen
      handleContinue={() => screeningIntroScreenVisitMutation()}
      content={getScreeningIntroScreenMessage(user)}
      profilePicturePath={
        user?.organization_patients[0]?.primary_provider?.profile_picture_path
      }
    />
  );
};
